import { createContext } from "react";

export interface AuftragsbestaetigungFromAngebotOpenOptions {
  angebotId: number;
}

export interface AuftragsbestaetigungFromAngebotContextValue {
  open: (options: AuftragsbestaetigungFromAngebotOpenOptions) => void;
  close: () => void;
  isOpen: boolean;
  angebotId: number | null;
}

export const AuftragsbestaetigungFromAngebotContext =
  createContext<AuftragsbestaetigungFromAngebotContextValue | null>(null);
